import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Footer, Header } from "components";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/dash");
  };

  return (
    <>
      <div className="grid-container">
        <div><Header/></div>

        <div style={{textAlign:"center", padding:"64px"}}>
          <h1>Greška!</h1>
          <p className="alert alert-danger">Stranica ne postoji.</p>

          <Button onClick={handleClick}>Povratak</Button>
        </div>

        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};
